// extracted by mini-css-extract-plugin
export default {"container":"ApiGuide_container__VpZsg","gap":"ApiGuide_gap__VRadO","bg":"ApiGuide_bg__fYXYI"};